import React from "react";

const About = () => {
    return (
        <div name="about" className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white">
            <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
                <div className="pb-4">
                    <p className="text-4xl font-bold">About</p>
                </div>
                <p className="text-l mt-10">
                    I am a software developer with a focus on front-end technologies.
                    My journey into the world of software development started about a
                    year ago when I studied with ALX-Africa. Prior to that, I had a background as
                    an architect, but I made the decision to leave that field and chase my dream
                    of making software development a professional career. Studing with Alx and Holberton
                    school helped me gain a strong foundation in various
                    front-end development skills. Now, as a software developer,
                    I am excited to apply the knowledge and skills I have gained to create innovative and
                    user-friendly digital experiences.

                </p>
        </div>
        </div>
    )
};

export default About